import React, { Fragment, useState } from "react";
import MarkdownRenderWithMath from "../../MarkdownRender/MarkdownRenderWithMath";
import ExternalCourseContextAwareToggle from "../../ExternalCourseCmponents/ExternalCourseContextAwareToggle/ExternalCourseContextAwareToggle";
import ExternalCourseAddLectureContent from "../../ExternalCourseCmponents/ExternalCourseAddLectureContent/ExternalCourseAddLectureContent";
import { generateUniqueId } from "../../../utils/utils";
import AddTopic from "./AddTopic/AddTopic";

const ExternalCourseAccordianAction = ({
  setCourseCurriculum,
  chapterId,
  chapterIndex,
  accordionItems,
}) => {
  const [topicEditObj, setTopicEditObj] = useState({});
  // article modal state
  const [showArticleModal, setShowArticleModal] = useState(false);

  const [headingExpanded, setHeadingExpanded] = useState({
    id: null,
    index: null,
  });
  const [topicExpanded, setTopicExpanded] = useState({
    id: null,
    index: null,
  });

  // handler func. to edit headings
  const handleEditHeading = (headingIndex, newHeadingValue) => {
    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      const chapterToUpdate = {
        ...updatedSections[0]?.chapters?.[chapterIndex],
      };
      const headingToUpdate = {
        ...chapterToUpdate.headings?.[headingIndex],
      };
      headingToUpdate.name = newHeadingValue;
      chapterToUpdate.headings[headingIndex] = headingToUpdate;
      updatedSections[0].chapters[chapterIndex] = chapterToUpdate;
      return updatedSections;
    });
  };

  // handler func. to delete headings
  const handleDeleteHeading = (headingIndex) => {
    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      const chapterToUpdate = {
        ...updatedSections[0]?.chapters?.[chapterIndex],
      };
      chapterToUpdate.headings.splice(headingIndex, 1); // Remove the heading at the specified index
      updatedSections[0].chapters[chapterIndex] = chapterToUpdate;
      return updatedSections;
    });
  };

  // handler func. to edit topics
  const handleEditTopic = (topicIndex, newTopicName) => {
    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      const chapterToUpdate = {
        ...updatedSections[0]?.chapters?.[chapterIndex],
      };
      const headingToUpdate = {
        ...chapterToUpdate.headings?.[headingExpanded.index],
      };
      const topicToUpdate = {
        ...headingToUpdate?.topics?.[topicIndex],
      };
      topicToUpdate.name = newTopicName;
      headingToUpdate.topics[topicIndex] = topicToUpdate;
      chapterToUpdate.headings[headingExpanded.index] = headingToUpdate;
      updatedSections[0].chapters[chapterIndex] = chapterToUpdate;
      return updatedSections;
    });
  };

  // handler func. to delete topics
  const handleDeleteTopic = (topicIndex) => {
    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      const chapterToUpdate = {
        ...updatedSections[0]?.chapters?.[chapterIndex],
      };
      const headingToUpdate = {
        ...chapterToUpdate.headings?.[headingExpanded.index],
      };
      headingToUpdate.topics.splice(topicIndex, 1); // Remove the topic at the specified index
      chapterToUpdate.headings[headingExpanded.index] = headingToUpdate;
      updatedSections[0].chapters[chapterIndex] = chapterToUpdate;
      return updatedSections;
    });
  };

  // handler func. to add new topic
  const addTopic = (newTopicName) => {
    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      const chapterToUpdate = {
        ...updatedSections[0]?.chapters?.[chapterIndex],
      };
      const headingToUpdate = {
        ...chapterToUpdate.headings?.[headingExpanded.index],
      };
      const newTopics = [
        ...headingToUpdate.topics,
        {
          name: newTopicName,
          id: generateUniqueId(),
          description: "",
          video_link: "",
          quiz: "",
          topic_tags: "",
          topic_category: "",
        },
      ];
      headingToUpdate.topics = newTopics;
      chapterToUpdate.headings[headingExpanded.index] = headingToUpdate;
      updatedSections[0].chapters[chapterIndex] = chapterToUpdate;
      return updatedSections;
    });
  };

  const generateKey = (pre) => {
    pre = pre.toLowerCase();
    pre = pre.replace(" ", "_");
    return `${pre}_${new Date().getTime()}`;
  };

  return (
    <Fragment>
      <div>
        {accordionItems?.map((item, index) => (
          <div
            key={generateKey(item.name + index)}
            className="px-2 py-2 mb-1 shadow-none bg-white mt-2"
          >
            <div className="bg-transparent border-0 p-0">
              <div className="border-0">
                <h3 className="mb-0 font-bold text-black/70 font-inter text-sm">
                  <ExternalCourseContextAwareToggle
                    expandableId={item._id}
                    expandableIndex={index}
                    editValue={item.name}
                    handleEditButtonClick={handleEditHeading}
                    handleDeleteButtonClick={handleDeleteHeading}
                    setExpanded={setHeadingExpanded}
                  >
                    {item.name}
                  </ExternalCourseContextAwareToggle>
                </h3>
              </div>
            </div>
            {item._id === headingExpanded.id && (
              <div>
                {item?.topics?.map((topic, ind) => (
                  <div className="px-2 py-1" key={topic.id}>
                    <h4 className="mb-0 font-bold text-black/70 font-inter text-sm">
                      <ExternalCourseContextAwareToggle
                        expandableId={topic.id}
                        expandableIndex={ind}
                        editValue={topic.name}
                        handleEditButtonClick={handleEditTopic}
                        handleDeleteButtonClick={handleDeleteTopic}
                        setExpanded={setTopicExpanded}
                      >
                        {topic.name}
                      </ExternalCourseContextAwareToggle>
                    </h4>

                    {topicExpanded.id === topic.id && (
                      <div>
                        <div className="p-4 flex flex-col space-y-2">
                          <div className="text-sm text-black font-inter font-normal line-clamp-5">
                            <p className="font-bold text-base">Description:</p>
                            <MarkdownRenderWithMath text={topic?.description} />
                          </div>
                          <p className="text-base text-black font-inter font-medium">
                            Lecture Content Title:{" "}
                            <span className="text-sm font-normal">
                              {topic?.name}
                            </span>
                          </p>
                          <div className="flex items-center space-x-2">
                            <button
                              className="bg-gray22 px-4 py-2 text-white text-sm font-inter font-medium rounded-md mb-1 w-max"
                              onClick={() => {
                                setShowArticleModal(true);
                                setTopicEditObj(topic);
                              }}
                            >
                              Edit Lecture Content
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                <AddTopic addTopic={addTopic} />
              </div>
            )}
            <ExternalCourseAddLectureContent
              currentObj={topicEditObj}
              setCurrentObj={setTopicEditObj}
              id={chapterId}
              setCourseCurriculum={setCourseCurriculum}
              setShowArticleModal={setShowArticleModal}
              showArticleModal={showArticleModal}
              chapterIndex={chapterIndex}
              headingIndex={headingExpanded.index}
              topicIndex={topicExpanded.index}
            />
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default ExternalCourseAccordianAction;
